import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserContextService {
  /**
   * Page actuel de l'utilisateur
   */
  public actualPage: string;

  /**
   * Menu selectionné par l'utilisateur
   */
  public menuSelected: string;

  /**
   * Information du context de l'utilisateur
   */
  private contextProperties = new Map<string, string>();

  /**
   * Ajoute ou modifie une Clé:Valeur de la liste des informations de context utilisateur
   */
  setContextProperty(key: ContextPropertiesKeys, value: string) {
    this.contextProperties.set(key, value);
  }

  /**
   * Récupère la liste des informations du context utilisateur sous forme de Clé:Valeur
   */
  getContextProperties() {
    return this.contextProperties;
  }

  /**
   * Vide la liste des informations du context utilisateur
   */
  resetContextProperty() {
    this.contextProperties.clear();
  }
}

export enum ContextPropertiesKeys {
  dkCodeSite = 'DK Code Site',
  deveui = 'DEVEUI',
  libelleSite = 'Libellé du site',
}
